module.exports = __webpack_public_path__ + "static/media/p7.db5ee114.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/brand/p7.svg
// module id = 704
// module chunks = 0